export const PATIENT_RECORD_STATUS = {
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
} as const;
